'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _tabs = require('./tabs');

var _tabs2 = _interopRequireDefault(_tabs);

var _reactSyntaxHighlighter = require('react-syntax-highlighter');

var _reactSyntaxHighlighter2 = _interopRequireDefault(_reactSyntaxHighlighter);

var _styles = require('react-syntax-highlighter/dist/styles');

var _reactCloseOnEscape = require('react-close-on-escape');

var _reactCloseOnEscape2 = _interopRequireDefault(_reactCloseOnEscape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var saveAs = void 0;
if (typeof window !== 'undefined') {
  saveAs = require('filesaver.js').saveAs;
}

var style = {
  position: 'absolute',
  width: '500px',
  height: '600px',
  right: '25px',
  bottom: '80px',
  backgroundColor: '#f8f8ff',
  color: 'black',
  boxShadow: '2px 2px 5px #888888',
  overflowY: 'auto',
  zIndex: 99
};

var xStyle = {
  float: 'right',
  fontSize: '22px',
  fontWeight: 700,
  marginRight: '5px',
  cursor: 'pointer',
  color: '#888888'
};

var saveStyle = {
  color: '#888888',
  fontSize: '22px',
  fontWeight: 600,
  cursor: 'pointer'
};

var onXClick = function onXClick(e, close) {
  e.preventDefault();
  close();
};

var DisplayTest = function (_React$Component) {
  _inherits(DisplayTest, _React$Component);

  function DisplayTest() {
    _classCallCheck(this, DisplayTest);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(DisplayTest).call(this));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  _createClass(DisplayTest, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('click', this.onClick);
      if (this.code) {
        this.code.setAttribute('contentEditable', true);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      // will be string true when getting attribute from native dom element
      if (this.code && this.code.getAttribute('contentEditable') !== 'true') {
        this.code.setAttribute('contentEditable', true);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.onClick);
    }
  }, {
    key: 'onClick',
    value: function onClick(_ref) {
      var target = _ref.target;

      if (this.container && !this.container.contains(target) && this.props.shouldShowTest() && target.className !== 'redux-test-recorder-record-button' && target.className !== 'redux-test-recorder-tabs' && target.className !== 'redux-test-recorder-tab' && target.className !== 'redux-test-recorder-show-tests' && target.className.baseVal !== 'redux-test-recorder-show-tests-svg' && target.parentNode.className.baseVal !== 'redux-test-recorder-show-tests-svg') {
        this.props.hideTest();
      }
    }
  }, {
    key: 'saveFile',
    value: function saveFile(e) {
      e.preventDefault();
      var hasTestIndex = this.props.testIndex !== null && this.props.testIndex !== undefined;
      var suffix = hasTestIndex ? '-' + (this.props.testIndex + 1) : '';
      var file = new Blob([this.props.getTest(this.props.testIndex)], { type: 'text/plain;charset=utf-8' });
      saveAs(file, 'test' + suffix + '.js');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props;
      var getTest = _props.getTest;
      var shouldShowTest = _props.shouldShowTest;
      var onKeyPress = _props.onKeyPress;
      var hideTest = _props.hideTest;
      var getNumTests = _props.getNumTests;
      var testIndex = _props.testIndex;
      var onTabClick = _props.onTabClick;

      if (!shouldShowTest()) {
        return null;
      }

      return _react2.default.createElement(
        _reactCloseOnEscape2.default,
        { onEscape: onKeyPress },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: style, ref: function ref(container) {
                return _this2.container = container;
              }, onClick: this.onClick },
            _react2.default.createElement(
              'span',
              { style: saveStyle, onClick: function onClick(e) {
                  return _this2.saveFile(e);
                } },
              'Save As File'
            ),
            _react2.default.createElement(
              'span',
              { style: xStyle, onClick: function onClick(e) {
                  return onXClick(e, hideTest);
                } },
              'X'
            ),
            _react2.default.createElement(
              'div',
              { ref: function ref(code) {
                  return _this2.code = code;
                }, style: { outline: 'none' } },
              _react2.default.createElement(
                'pre',
                null,
                _react2.default.createElement(
                  'code',
                  null,
                  _react2.default.createElement(
                    _reactSyntaxHighlighter2.default,
                    { language: 'javascript', style: _styles.docco },
                    getTest(testIndex)
                  )
                )
              )
            )
          ),
          _react2.default.createElement(_tabs2.default, { numTests: getNumTests(), onTabClick: onTabClick, testIndex: testIndex })
        )
      );
    }
  }]);

  return DisplayTest;
}(_react2.default.Component);

exports.default = DisplayTest;


/*****************
 ** WEBPACK FOOTER
 ** ./dist/display-test.js
 ** module id = 184
 ** module chunks = 0
 **/